import * as Yup from "yup";

export const policyFormSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  title: Yup.string().required("Title is required"),
  description: Yup.string().required("Description is required"),
});
